import React from "react";

import { categories, topics } from "../Data";

const Options = ({
  categoryParam,
  category,
  topicParam,
  topic,
  shuffleGroups,
  shuffleQuestions,
  shuffleAnswers,
  showNumbers,
  showAnswers,
  modulus,
  resetOptions,
  onResetAnswers,
  exam,
  finished,
  dispatch,
}) => {
  const effectiveText = topic ? topic : category;

  const onSubmit = (e) => {
    e.preventDefault();
  };
  return (
    <main>
      <form className="row" onSubmit={onSubmit}>
        <div className="col-12">
          <label className="form-label me-sm-2" htmlFor="category">
            Categories
          </label>
          <select
            readOnly={exam || categoryParam}
            disabled={exam || categoryParam}
            className="form-control me-sm-2"
            id="category"
            value={category}
            onChange={(e) =>
              dispatch({
                type: "setCategory",
                payload: e.currentTarget.value,
              })
            }
          >
            <option value="">All</option>
            {categories().map((i) => (
              <option key={i} value={i}>
                {i}
              </option>
            ))}
          </select>
        </div>
        <div className="col-12">
          <label className="form-label mr-sm-2" htmlFor="topic">
            Topics
          </label>
          <select
            className="form-control  mr-sm-2"
            id="topic"
            value={topic}
            readOnly={exam || topicParam || !category}
            disabled={exam || topicParam || !category}
            onChange={(e) =>
              dispatch({ type: "setTopic", payload: e.currentTarget.value })
            }
          >
            <option value="">All</option>
            {topics(category).map((i) => (
              <option key={i} value={i}>
                {i}
              </option>
            ))}
          </select>
        </div>
        <div className="col-12">
          <div className="form-check">
            <input
              readOnly={exam}
              disabled={exam}
              type="checkbox"
              className="form-check-input mr-sm-2"
              id="shuffleGroups"
              checked={shuffleGroups}
              onChange={(e) =>
                dispatch({
                  type: "setShuffleGroups",
                  payload: e.currentTarget.checked,
                })
              }
            ></input>
            <label
              className="form-check-label mr-sm-2 "
              htmlFor="shuffleGroups"
            >
              Shuffle Categories and Topics
            </label>
          </div>
        </div>
        <div className="col-12">
          <div className="form-check">
            <input
              readOnly={exam}
              disabled={exam}
              type="checkbox"
              className="form-check-input mr-sm-2"
              id="shuffleQuestions"
              checked={shuffleQuestions}
              onChange={(e) =>
                dispatch({
                  type: "setShuffleQuestions",
                  payload: e.currentTarget.checked,
                })
              }
            ></input>
            <label
              className="form-check-label mr-sm-2 "
              htmlFor="shuffleQuestions"
            >
              Shuffle Questions
            </label>
          </div>
        </div>
        <div className="col-12">
          <div className="form-check">
            <input
              readOnly={exam}
              disabled={exam}
              type="checkbox"
              className="form-check-input mr-sm-2"
              id="shuffleAnswers"
              checked={shuffleAnswers}
              onChange={(e) =>
                dispatch({
                  type: "setShuffleAnswers",
                  payload: e.currentTarget.checked,
                })
              }
            ></input>
            <label
              className="form-check-label mr-sm-2 "
              htmlFor="shuffleAnswers"
            >
              Shuffle Answers
            </label>
          </div>
        </div>
        <div className="col-12">
          <div className="form-check">
            <input
              readOnly={exam}
              disabled={exam}
              type="checkbox"
              className="form-check-input mr-sm-2"
              id="showNumbers"
              checked={showNumbers}
              onChange={(e) =>
                dispatch({
                  type: "setShowNumbers",
                  payload: e.currentTarget.checked,
                })
              }
            ></input>
            <label className="form-check-label mr-sm-2 " htmlFor="showNumbers">
              Show Numbers
            </label>
          </div>
        </div>
        <div className="col-12">
          <div className="form-check">
            <input
              readOnly={exam}
              disabled={exam}
              type="checkbox"
              className="form-check-input mr-sm-2"
              id="showAnswers"
              checked={showAnswers}
              onChange={(e) =>
                dispatch({
                  type: "setShowAnswers",
                  payload: e.currentTarget.checked,
                })
              }
            ></input>
            <label className="form-check-label mr-sm-2 " htmlFor="showAnswers">
              Show Answers
            </label>
          </div>
        </div>
        <div className="col-12">
          <label className="form-label" htmlFor="modulus">
            Modulus
          </label>
          <input
            readOnly={exam}
            disabled={exam}
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
            className="form-control"
            id="modulus"
            value={modulus}
            min={1}
            onChange={(e) =>
              dispatch({
                type: "setModulus",
                payload: e.currentTarget.value,
              })
            }
          />
        </div>
        <div className="d-grid gap-2">
          <button
            type="reset"
            className="btn btn-outline-danger"
            onClick={(e) => {
              e.preventDefault();
              dispatch({ type: "resetOptions" });
            }}
          >
            Reset Options
          </button>
        </div>
        <div className="d-grid gap-2">
          <button
            type="reset"
            disabled={finished}
            className="btn btn-outline-danger"
            onClick={(e) => {
              e.preventDefault();
              onResetAnswers();
            }}
          >
            Reset {effectiveText} Answers
          </button>
        </div>
      </form>
    </main>
  );
};

export default Options;
